import Geocoder from 'geocoder';

export default {
  data() {
    return {
      currentLocation: {
        lat: 59.922011,
        lng: 10.752838,
      },
    };
  },

  props: {
    /**
     * The address to mark on the map.
     */
    streetName: {
      type: String,
      required: true,
    },
  },

  watch: {
    /**
     * Watches changes on address to update map.
     */
    streetName() {
      this.geolocation();
    },
  },

  mounted() {
    this.geolocation();
  },

  methods: {
    /**
     * Fetch coordinates based on address.
     */
    geolocation() {
      Geocoder.geocode(this.streetName, (err, data) => {
        if (err === null) {
          if (data.results.length) {
            this.currentLocation.lat = data.results[0].geometry.location.lat;
            this.currentLocation.lng = data.results[0].geometry.location.lng;
          } else {
            console.log('No results for address.');
          }
        } else {
          console.log(err);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/map/map.js